import { render, staticRenderFns } from "./CategoriesSelect.vue?vue&type=template&id=025f0c19&scoped=true"
import script from "./CategoriesSelect.vue?vue&type=script&lang=ts"
export * from "./CategoriesSelect.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesSelect.vue?vue&type=style&index=0&id=025f0c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f0c19",
  null
  
)

export default component.exports